import { useQuery } from '@tanstack/react-query'
import { API_URL } from '../const'
import { Lingua } from '../types'
import axios from 'axios'
import { serializeQueryParams } from './utils'
import { useAuthUser } from 'use-eazy-auth'

export function findLanguageByCode(
  languages: Lingua[] | undefined,
  code: string
) {
  const normalizedCode = code.toLowerCase()
  return languages?.find(
    (language) => language.code.toLowerCase() === normalizedCode
  )
}

export async function getLanguages(
  params: Record<string, any> = {},
  token?: string,
  signal?: AbortSignal
) {
  return (
    await axios.get(`${API_URL}/languages/`, {
      signal,
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
      params: serializeQueryParams(params),
    })
  ).data as Lingua[]
}

export function useLingue(params: Record<string, any> = {}) {
  const userData = useAuthUser()
  const token = userData?.token

  return useQuery({
    queryKey: ['lingue', params, token],
    queryFn: ({ signal }) => getLanguages(params, token, signal),
    keepPreviousData: true,
    suspense: false,
    enabled: !!token,
  })
}
